import Account from '@/utils/api/odas/account';
import mapValues from 'lodash/mapValues';

const passwordValidationString = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[/\W/g_])[A-Za-z\d/\W/g_]{8,}$/;

let samlConfigPromise = null;

const accountHelpers = {
  checkPassword: (value) => {
    return value.match(passwordValidationString);
  },
  fetchSamlConfig: () => {
    if (samlConfigPromise === null) {
      samlConfigPromise = Account.getSAMLConfiguration().then((response) => {
        return mapValues(response?.data?.saml_config, (partner, slug) => {
          return Object.assign({ slug }, partner, { email_regex: new RegExp(partner.email_regex.trim().replace(/^\//, '').replace(/\/$/, ''), 'i') });
        });
      });
    }
    return samlConfigPromise;
  },
  isPasswordMatched: (password, password_confirmation) => {
    return password === password_confirmation;
  },
  enqueueSignupModalFlow: ({ enqueueModal, modalData, onFlowComplete = () => {}, ...options } = {}) => {
    // A member affiliating within an SSO network is approved on the spot, and the API ends the session of
    // anyone whose approved affiliation changed since they signed in. So for those members the affiliation
    // step goes last: everything else is saved while the session is still good, and the affiliation modal
    // finishes by handing them a deliberate trip back through login.
    const affiliatesThroughSsoNetwork = !!modalData?.affiliation_list;

    if (!affiliatesThroughSsoNetwork && modalData?.user?.is_professional) {
      enqueueModal({
        name: 'SignupProDetails',
        affiliationData: modalData?.user?.affiliation
      });
    }

    enqueueModal({
      name: 'SignupMemberDetails',
      afterSubmit: affiliatesThroughSsoNetwork ? undefined : onFlowComplete
    });

    if (affiliatesThroughSsoNetwork) {
      enqueueModal({
        name: 'SignupAffiliationDetails',
        affiliationData: modalData,
        afterSubmit: onFlowComplete
      });
    }
  }
};

export default accountHelpers;
